/* eslint-disable no-underscore-dangle */
import http from '@/tool/http/http'

function service() {
  const Services = {}
  // 获取设岗单位列表
  Services._currentJobs = data => http.GET('/api/jobs/currentJobs', data)
  // 获取某单位下所有岗位
  Services._jobsOfUnit = data => http.GET('/api/jobs/jobsOfUnit', data)
  // 获取所有发布审核列表
  Services._jobsOfAll = data => http.POST('/api/jobs/all', data, '接口异常', 300000)
  // 用工单位-当前岗位列表
  Services._currentJobs = data => http.GET('/api/jobs/currentJobs', data)
  // 发布岗位
  Services._createJob = data => http.POST('/api/jobs/createJob', data)
  // 岗位发布历史
  Services._historyJobs = data => http.GET('/api/jobs/history', data)
  // 学生端招聘公共
  Services._onRecruit = data => http.POST('/api/jobs/recruit', data)
  // 学工端审核岗位发布
  Services._checkUnit = data => http.POST('/api/jobs/check', data)
  // 关闭岗位
  Services._closeJob = data => http.POST(`/api/jobs/closeJob/${data.id}`, data)
  // 扩充人数
  Services._extensionJob = data => http.POST('/api/jobs/extension', data)
  // 学生上岗审批列表
  Services._schoolOrUnit = data => http.POST('/api/jobs/schoolOrUnit', data)
  // 学生-申请岗位
  Services._applyUnit = data => http.POST('/api/jobs/apply', data)
  // 单位详情-岗位列表
  Services._unitSearch = data => http.POST('/api/jobs/unit_search', data)
  // 岗位招聘审核列表
  Services._applicationsCheck = id => http.GET(`/api/jobs/${id}/applications`)
  // 结束招聘判断
  Services._finishCheck = id => http.POST(`/api/jobs/finishCheck/${id}`)
  // 结束聘用
  Services._finishJob = id => http.POST(`/api/jobs/finish/${id}`)
  // 开启招聘
  Services._beginRecruit = data => http.POST('/api/jobs/beginRecruit', data)
  // 查询固定岗位有效期
  Services._positionFixedDate = () => http.POST('/api/units/query')
  // 修改岗位信息
  Services._updatePositionDetails = data => http.POST('/api/jobs/updateJob', data)
  // 模糊查询岗位信息
  Services._queryJobNameByName = data => http.POST('/api/jobs/dim/queryJobName', data)
  // 批量审核
  Services._batchCheck = data => http.POST('/api/jobs/batchCheck', data)
  // 学生-招聘公告列表
  Services._recruitDetail = recruitId => http.GET(`/api/jobs/recruitDetail/${recruitId}`)
  // 学校强制关闭岗位
  Services._positiveCloseJob = data => http.POST(`/api/jobs/statictis/positiveCloseJob/${data.jobId}`, data)
  // 学生-修改银行卡号
  Services._editBank = data => http.POST('/api/jobs/editBank', data)
  return Services
}
export default service
